import { useEffect, useState } from "react";

export default function AssistantButton({
    toggleMenu,
    showMenu,
    popitoUrl,
    totalUnread,
    hasUnreadAnnouncements,
    onOpenAnnouncements,
    buttonRef,
    style,
    isDragging,
    onDragStart,
}) {
    const className = isDragging ? "dragging" : "";
    const hasUnreadMessages = totalUnread > 0;
    const imgClass = hasUnreadMessages ? "has-unread" : "";
    const [bubbleDismissed, setBubbleDismissed] = useState(false);

    const handleAnnouncementClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (typeof onOpenAnnouncements === 'function') {
            onOpenAnnouncements();
        }
    };

    const handleBubbleClose = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setBubbleDismissed(true);
    };

    useEffect(() => {
        if (hasUnreadAnnouncements) {
            setBubbleDismissed(false);
        }
    }, [hasUnreadAnnouncements]);

    return (
        <div
            id="assistant-button"
            ref={buttonRef}
            className={className}
            style={style}
            onClick={toggleMenu}
            onMouseDown={onDragStart}
        >
            <img src={popitoUrl} alt="Assistant pet" id="assistant-image" className={imgClass} />
            <span className="assistant-label">BETA</span>
            {totalUnread > 0 && <span className="assistant-button-top-label">{totalUnread}</span>}
            {hasUnreadAnnouncements && !bubbleDismissed && (
                <div className="assistant-announcement-bubble" role="status" aria-live="polite">
                    <button
                        type="button"
                        className="assistant-announcement-close"
                        aria-label="Cerrar aviso"
                        onClick={handleBubbleClose}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                        </svg>
                    </button>
                    <span className="assistant-announcement-text">¡Tengo un anuncio importante para ti!</span>
                    <button
                        type="button"
                        className="assistant-announcement-link"
                        onClick={handleAnnouncementClick}
                    >
                        Ver anuncios
                    </button>
                </div>
            )}
        </div>
    );
}
